import * as React from 'react';
import { cn } from '../lib/utils';

const carouselStyles = /* css */ `
.native-carousel {
	overflow-x: auto;
	overscroll-behavior-x: contain;
	scroll-snap-type: x mandatory;
	anchor-name: --native-carousel;
	-ms-overflow-style: none;
	scrollbar-width: none;

	@media (prefers-reduced-motion: no-preference) {
		scroll-behavior: smooth;
	}
}

.native-carousel::-webkit-scrollbar {
	display: none;
}

.native-carousel > * {
	scroll-snap-align: center;
}

.native-carousel::scroll-button(*) {
	transition: opacity 0.1s ease-in-out;
	position: fixed;
	position-anchor: --native-carousel;
	position-visibility: always;
	margin: 8px;

	inline-size: 42px;
	line-height: 0.6;
	aspect-ratio: 1;
	border-radius: 1e3px;
	border: 1px solid var(--native-carousel-btn-border, rgba(255 255 255 / 50%));
	background-color: var(--native-carousel-btn-bg, var(--color-dark, #1a1a1a));
	color: var(--native-carousel-btn-color, var(--color-primary-foreground, #fff));
}

.native-carousel::scroll-button(*):not(:disabled):active {
	scale: 90%;
}

.native-carousel::scroll-button(*):disabled {
	opacity: 0;
	cursor: unset;
}

.native-carousel::scroll-button(left) {
	position-area: center span-inline-end;
	content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>') /
		'Scroll Left';
}

.native-carousel::scroll-button(right) {
	position-area: center span-inline-start;
	content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>') /
		'Scroll Right';
}
`;

function useInjectStyles() {
	React.useEffect(() => {
		const id = 'native-carousel-styles';
		if (document.getElementById(id)) return;
		const style = document.createElement('style');
		style.id = id;
		style.textContent = carouselStyles;
		document.head.appendChild(style);
	}, []);
}

function NativeCarousel({ className, children, ...props }: React.ComponentProps<'ul'>) {
	useInjectStyles();

	return (
		<ul className={cn('native-carousel flex w-full touch-pan-x gap-4 px-6', className)} {...props}>
			{children}
		</ul>
	);
}

function NativeCarouselItem({ className, ...props }: React.ComponentProps<'li'>) {
	return <li className={cn('shrink-0', className)} {...props} />;
}

export { NativeCarousel, NativeCarouselItem };
